const initialState = {
  blogDetail: null,
  isLoading: null,
  isError: null,
};

export default initialState;
